// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__tEjrA","slick-next":"CustomSlider_slick-next__yl5Q8"};